import { useAuth0 } from "@auth0/auth0-react";
import BackSvgComponent from "assets/icons/svg/back";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { InputField, LabelField, MyCheckbox } from "components";
import MyButton from "components/MyButton";
import { TextareaField } from "components/TextareaField";
import { useDisableEnterKey, useSearch } from "hook";
import DonationService from "Lib/API/Donation";
import React, { useEffect, useState } from "react";
import { Col, Row, ToastHeader } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select-v2";
import { emailValidation } from "utils/validation";
import FinanceService from "../../../Lib/API/Finance";

const TributeInformation = ({
  setsavetribute,
  formik,
  id,
  editAction,
  setTributeAdd,
  closeModal,
  viewClick,
  setTributeList,
  refetchExport
}) => {
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = useState("");
  const { searchAction } = useSearch({ action: setSearch });
  const [data, setData] = useState();
  const { getAccessTokenSilently } = useAuth0();
  const enableLoading = (value) => {
    setLoading(value);
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const formatOptionLabel = ({ label, account_id }) => {
    return (
      <div className="dropdown-container" key={account_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const addTributebyId = async (e) => {
    e.preventDefault();

    const attributeId = id;

    const token = await getAccessTokenSilently();
    if (!formik.values?.tribute_type) {
      return toastr.info("validation error", "please select tribute type ");
    }
    if (!formik.values?.donor_name) {
      return toastr.info("validation error", "please fill donor name field");
    }

    const error = formik.values?.showAcknowledgement ? formik?.values?.acknowledgements?.some((item) => {
      if (!item?.recipient_name) {
        toastr.info("validation error", "Donation Recipient Name is required");
        return true;
      }
      if (!item?.email) {
        toastr.info("validation error", "Email is required");
        return true;
      }
      if (!emailValidation(item?.email)) {
        toastr.info("validation error", "Email is not valid");
        return true;
      }
    }) : false;

    if (error) {
      return;
    }

    await DonationService.addTributeById(
      attributeId,
      {
        tribute_info: {
          type:
            formik.values?.tribute_type?.name ?? formik.values?.tribute_type,
            name: formik.values?.donor_name,
          message: formik?.values?.note ? formik?.values?.note : undefined,
          acknowledgment: formik?.values?.showAcknowledgement,
          recipients:  formik.values?.showAcknowledgement ? formik?.values?.acknowledgements : undefined,
        },
      },
      token
    )
      .then(() => {
        toastr.success("Success", "Added");
        setTributeAdd(true);
        closeModal();
        refetchExport();
      })
      .catch((e) => {
        toastr.error("Error", e?.data?.message);
      });
  };
  const editTributebyId = async (e) => {
    e.preventDefault();
    setTributeList(false);
    const attributeId = id;
    const token = await getAccessTokenSilently();
    if (!formik.values?.tribute_type) {
      return toastr.info("validation error", "please select tribute type ");
    }
    if (!formik.values?.donor_name) {
      return toastr.info("validation error", "please fill donor name field");
    }
   
    const error =  formik.values?.showAcknowledgement ? formik?.values?.acknowledgements?.some((item) => {
      if (!item?.recipient_name) {
        toastr.info("validation error", "Donation Recipient Name is required");
        return true;
      }
      if (!item?.email) {
        toastr.info("validation error", "Email is required");
        return true;
      }
      if (!emailValidation(item?.email)) {
        toastr.info("validation error", "Email is not valid");
        return true;
      }
    }) : false;

    if (error) {
      return;
    }

    await DonationService.editTributeById(
      attributeId,
      {
        tribute_info: {
          type:
            formik.values?.tribute_type?.name ?? formik.values?.tribute_type,
            name: formik.values?.donor_name,
          message: formik?.values?.note ? formik?.values?.note : undefined,
          acknowledgment: formik?.values?.showAcknowledgement,
          recipients: formik.values?.showAcknowledgement ? formik?.values?.acknowledgements : undefined,
        },
      },
      token
    )
      .then(() => {
        toastr.success("Success", "Updated");
        closeModal();
        setTributeList(true);
        refetchExport();
      })
      .catch((e) => {
        if (e?.data?.message) toastr.error("Error", e?.data?.message);
      });
  };
  useEffect(() => {
    async function fetchMyAPI() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getACcountNames(token, search).then((res) => {
        if (res?.accounts) {
          res.accounts.map((item) => {
            item.label = item.family_name;
            item.value = item.account_id;
            return item;
          });

          setData(res?.accounts);
        }
        enableLoading(false);
      }).catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
    }
    fetchMyAPI();
  }, [search, getAccessTokenSilently]);

  
  const addRecipientHandler = () => {
    const error = formik?.values?.acknowledgements?.some((item) => {
      if (!item?.recipient_name) {
        toastr.info("validation error", "Donation Recipient Name is required");
        return true;
      }

      if (!item?.email) {
        toastr.info("validation error", "Email is required");
        return true;
      }

      if (!emailValidation(item?.email)) {
        toastr.info("validation error", "Email is not valid");
        return true;
      }
    });


    if (error) {
      return;
    }

    formik.setFieldValue(`acknowledgements`, [
      ...formik?.values?.acknowledgements,
      {
        recipient_name: "",
        email: "",
      },
    ]);
  };

  const deleteRecipientHandler = (acknowledgementIndex) => {
    if (formik?.values?.acknowledgements?.length === 1) {
      return toastr.info("validation error", "At least one recipient is required");
    }
    const updatedAcknowledgements = formik?.values?.acknowledgements.filter(
      (item, index) => index !== acknowledgementIndex
    );
    
    formik.setFieldValue(`acknowledgements`, updatedAcknowledgements);
  }

  useDisableEnterKey(true);


  return (
    <div className="" style={{ width: "800px" }}>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className=" col-sm-12 pr-10 pt-5 pb-5 tribute-info__wrapper">
        <Row className="form-row sm-12">
            <Col
              className={
                viewClick === true
                  ? "col-12 col-md-6 tribute-text disabled-action"
                  : "col-12 col-md-6  tribute-text"
              }
            >
              <LabelField title="Tribute Type" 
                mandatory={true}
              />
              <Select
                {...{
                  formik,
                  name: `tribute_type`,
                  checkValidation: true,
                }}
                onInputChange={(text) => searchAction(text)}
                classNamePrefix="react-select"
                formatOptionLabel={formatOptionLabel}
                options={[
                  { id: "honor-of", label: "In honor of" },
                  { id: "memory-of", label: "In memory of" },
                ]}
                isLoading={loading}
                styles={colourStyles}
                onChange={(value) => {
                  formik.setFieldValue(`tribute_type`, {
                    id: value.id,
                    name: value.label,
                  });
                }}
                value={
                  formik.values?.tribute_type === "In honor of"
                    ? {
                        label: formik.values?.tribute_type,
                        value: "honor-of",
                      }
                    : formik.values?.tribute_type === "In memory of"
                    ? {
                        label: formik.values?.tribute_type,
                        value: "memory-of",
                      }
                    : formik.values?.tribute_type
                    ? {
                        label: formik.values?.tribute_type?.name,
                        value: formik.values?.tribute_type?.id,
                      }
                    : ""
                }
                components={{ DropdownIndicator }}
              />
            </Col>
            <Col
              className={
                viewClick === true ? "col-12 col-md-6 disabled-action" : "col-12 col-md-6 "
              }
            >
              <InputField
                {...{
                  formik,
                  title: "Name",
                  name: "donor_name",
                  placeholder: "",
                  mandatory: true,
                }}
                value={formik.values?.donor_name}
              />
            </Col>
        </Row>
          <Row className="form-row sm-12">
            <Col
              className={
                viewClick === true
                  ? "col-12 col-md-12 disabled-action"
                  : "col-12 col-md-12  "
              }
            >
              <TextareaField
                {...{
                  formik,
                  rows: 4,
                  title: "Tribute Message",
                  name: "note",
                  placeholder: "Tribute text",
                  style: { resize: "none" },
                }}
                value={formik.values?.note}
              />
            </Col>
          </Row>
          <div>
          <Row className="form-row sm-12">
            <Col className="col-12 col-md-12 send-acknowledgement-email">
              <MyCheckbox
                title="Send acknowledgement email to"
                checked={formik.values?.showAcknowledgement}
                handlechange={(event) => {
                  formik.setFieldValue(
                    `showAcknowledgement`,
                    !formik.values?.showAcknowledgement
                  );
                  if(!formik.values?.acknowledgements || formik.values?.acknowledgements.length === 0){
                    formik.setFieldValue(`acknowledgements`, [{
                      recipient_name: "",
                      email: "",
                    }]);
                  }
                }}
                disabled={viewClick}
              />
            </Col>
          </Row>
          {formik.values?.showAcknowledgement && (
          <div>
            {formik?.values?.acknowledgements?.map((acknowledgement, acknowledgementIndex) => (
              <Row className="form-row sm-12 flex-nowrap" key={acknowledgementIndex}>
                <Col
                  className={
                    viewClick === true ? "col-12 col-md-6 disabled-action" : "col-12 col-md-6"
                  }
                >
                  <InputField
                    {...{
                      formik,
                      title: "Donation Recipient Name",
                      name: `acknowledgements[${acknowledgementIndex}].recipient_name`,
                      placeholder: "",
                      mandatory: true,
                    }}
                    value={formik.values?.acknowledgements[acknowledgementIndex]?.recipient_name || ""}
                  />
                </Col>
                <Col
                  className={
                    viewClick === true
                      ? "col-12 col-md-6 tribute-text disabled-action"
                      : "col-12 col-md-6 tribute-text "
                  }
                >
                  <InputField
                    {...{
                      formik,
                      title: "Email",
                      name: `acknowledgements[${acknowledgementIndex}].email`,
                      placeholder: "",
                      mandatory: true,
                    }}
                    value={formik.values?.acknowledgements[acknowledgementIndex]?.email || ""}
                  />
                </Col>
                {formik.values?.acknowledgements?.length > 1 && (
                  <div
                    className={`delete_donation_recipient ${viewClick ? "tribute-disabled-action" : ""}`}
                    onClick={() => deleteRecipientHandler(acknowledgementIndex)}
                  >
                    <BackSvgComponent />
                  </div>
                )}
              </Row>
            ))}
            <Row className="form-row sm-12 ">
              <Col className="col-12 mt-5">
                <div className={`addRecipient ${viewClick ? "tribute-disabled-action" : ""}`} 
                onClick={addRecipientHandler}>
                  + Add Recipient
                </div>
              </Col>
            </Row>
            </div>
          )}
          </div>
          {viewClick === true ? (
            ""
          ) : (
            <div className="mb-4 btn-flex">
              <MyButton
                type={"primary"}
                style={{ width: "100px" }}
                content={"Save"}
                onClick={(e) =>
                  editAction === "edit_tribute"
                    ? editTributebyId(e)
                    : addTributebyId(e)
                }
              />
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default TributeInformation;
